import withAemIntegration from "../../withAemIntegration";

import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/FCVGallery")
);

const GalleryEditConfig = {
  emptyLabel: "Gallery",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  return {
    props: {
      images: props.galleryItems.map((item) => ({
        title: item.galleryVideoTitle,
        thumbnail: {
          desktop: {
            id: "",
            type: "mobile",
            src: item.gallerySmallImage,
            alt: item.galleryImageAltTag,
            width: "",
            height: "",
            disclaimer: {
              position: item.disclaimerPosition,
              color: item.disclaimerColor,
              text: item.disclaimer,
            },
          },
        },
        media: {
          image: {
            mobile: {
              id: "",
              type: "mobile",
              src: item.gallerySmallImage,
              alt: item.galleryImageAltTag,
              width: "",
              height: "",
              disclaimer: {
                position: item.disclaimerPosition,
                color: item.disclaimerColor,
                text: item.disclaimer,
              },
            },
            desktop: {
              id: "",
              type: "desktop",
              src: item.galleryImage,
              alt: item.galleryImageAltTag,
              width: "",
              height: "",
              disclaimer: {
                position: item.disclaimerPosition,
                color: item.disclaimerColor,
                text: item.disclaimer,
              },
            },
          },
          interactiveVideo:
            item.galleryVideoMP4 || item.galleryVideoWebM
              ? {
                  mp4: item.galleryVideoMP4,
                  webm: item.galleryVideoWebM,
                }
              : undefined,
        },
      })),
    },
  };
};

const Gallery = (props) => {
  const data = transformData(props);
  return <Component {...data.props} />;
};

export default withAemIntegration("lexus/components/gallery")(
  Gallery,
  GalleryEditConfig
);
